import React, { useState } from "react";
import { useAuth } from "./useAuth";

interface initialState {
  searchedPOText: string;
}
interface ICustomer {
  customerGlobalStates: initialState;
  updateState: (_key: string, _value: any) => void;
}
const initialStates: initialState = {
  searchedPOText: "",
};
export const CustomerContext = React.createContext<ICustomer>({
  customerGlobalStates: initialStates,
  updateState: (_key: string, _value: any) => { },
});

export function useCustomerManager() {

  const auth = useAuth();
  const [customerGlobalStates, setCustomerGlobalStates] =
    useState<any>(initialStates);

  const updateState = (key: string, value: any) => {
    setCustomerGlobalStates((prevState: any) => ({
      ...prevState,
      [key]: value,
    }));
  };

  
  // Return the Customer object and methods
  return {
    customerGlobalStates,
    updateState,
    

  };
}

export function useCustomer() {
  return React.useContext(CustomerContext);
}
